import {Path, Svg} from 'react-native-svg'

import {useSemanticTokens} from '#/wsocial/service/design-system'

export const MailIcon = () => {
  const tokens = useSemanticTokens()
  return (
    <Svg
      width="18"
      height="18"
      viewBox="0 0 15 12"
      fill="none"
      style={{flexShrink: 0}}>
      <Path
        fill={tokens.onboarding.btnPrimaryBg}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.926 0H13.074C13.263 0 13.4475 0 13.6035 0.01275C13.7753 0.027 13.9778 0.06 14.181 0.1635C14.4632 0.307308 14.6927 0.536769 14.8365 0.819C14.94 1.02225 14.973 1.22475 14.9872 1.3965C15 1.5525 15 1.737 15 1.926V10.074C15 10.263 15 10.4475 14.9872 10.6035C14.9758 10.8041 14.9245 11.0004 14.8365 11.181C14.6927 11.4632 14.4632 11.6927 14.181 11.8365C14.0004 11.9245 13.8041 11.9758 13.6035 11.9872C13.4475 12 13.263 12 13.074 12H1.926C1.737 12 1.5525 12 1.3965 11.9872C1.19591 11.9758 0.999613 11.9245 0.819 11.8365C0.536769 11.6927 0.307308 11.4632 0.1635 11.181C0.0754908 11.0004 0.0242485 10.8041 0.01275 10.6035C0 10.4475 0 10.263 0 10.074V1.926C0 1.737 0 1.5525 0.01275 1.3965C0.027 1.22475 0.06 1.02225 0.1635 0.819C0.307308 0.536769 0.536769 0.307308 0.819 0.1635C1.02225 0.06 1.22475 0.027 1.3965 0.01275C1.5525 0 1.737 0 1.926 0ZM2.268 1.5L7.5 5.781L12.732 1.5H2.268ZM13.5 2.81025L8.45025 6.942C8.1822 7.16147 7.84644 7.28139 7.5 7.28139C7.15356 7.28139 6.8178 7.16147 6.54975 6.942L1.5 2.8095V10.05C1.49745 10.1973 1.5002 10.3446 1.50825 10.4918H1.51875C1.60575 10.4993 1.72725 10.5 1.95 10.5H13.05C13.1973 10.5023 13.3447 10.4993 13.4918 10.491V10.4813C13.4993 10.3943 13.5 10.272 13.5 10.05V2.81025Z"
      />
    </Svg>
  )
}

export default MailIcon
